import { jsx as e, jsxs as d } from "react/jsx-runtime";
import a from "react";
import { useI18n as D } from "next-localization";
import { u as $ } from "../../chunks/use-footer-in-view.CB2TZ3uk.js";
import { NeuPanel as v, NeuFeedback as j, NeuButton as A } from "@hcahealthcaredpx/neutron-react";
import { u as q } from "../../chunks/use-sitecore-context.C7g4vcbm.js";
import H from "next/script";
const O = ({ podiumLink: t }) => /* @__PURE__ */ e(H, { src: t, async: !0, id: "podium-widget" }), M = "mammo-bot-btn", R = "clearstep-btn", W = ({ fields: t, rendering: l }) => {
  var w, y, B;
  const { t: p } = D(), {
    sitecoreContext: { route: k }
  } = q(), c = k == null ? void 0 : k.itemId, h = !!(c && ((w = t == null ? void 0 : t.mammoPageInclusions) != null && w.includes(c)) && (t != null && t.mammoLink)), r = !!(c && ((y = t == null ? void 0 : t.podiumPageInclusions) != null && y.includes(c)) && (t != null && t.podiumLink)), m = !!(c && // Clearstep is different - it's an exclusion list, the other bots are inclusion lists
  !((B = t == null ? void 0 : t.clearstepPageExclusions) != null && B.includes(c)) && (t != null && t.clearstepLink) && !r), { isFooterInView: L } = $(), u = h || r || m, [N, C] = a.useState(!1), [E, T] = a.useState(0), [g, b] = a.useState(!1), [S, P] = a.useState(void 0);
  return a.useEffect(() => {
    if (u && typeof document < "u") {
      const n = (o) => {
        const x = o.currentTarget, F = x.classList.contains(M), _ = x.classList.contains(R), I = F ? t == null ? void 0 : t.mammoLink : _ ? t == null ? void 0 : t.clearstepLink : void 0;
        I && (P(I), o.preventDefault(), C(!0));
      }, s = document.querySelectorAll(`.${M}`);
      h && s.length > 0 && s.forEach((o) => o.addEventListener("click", n));
      const i = document.querySelectorAll(`.${R}`);
      return m && i.length > 0 && i.forEach((o) => o.addEventListener("click", n)), () => {
        s == null || s.forEach((o) => o.removeEventListener("click", n)), i == null || i.forEach((o) => o.removeEventListener("click", n));
      };
    }
  }, [t.clearstepLink, t.mammoLink, m, h, u]), a.useEffect(() => {
    if (typeof document < "u" && r) {
      const n = document.getElementById("podium-website-widget");
      n && (n.style.display = L ? "none" : "block");
    }
  }, [r, L]), u && /* @__PURE__ */ d("div", { "data-test-id": l == null ? void 0 : l.componentName, children: [
    r && /* @__PURE__ */ e(O, { podiumLink: t.podiumLink }),
    S && u && /* @__PURE__ */ d(
      v,
      {
        active: N,
        backdropDismiss: !0,
        label: p("PageContent.Chatbot.ModalTitle"),
        color: "gray",
        level: 1,
        onNeuDismiss: () => {
          C(!1), b(!1);
        },
        children: [
          /* @__PURE__ */ e(v.Content, { children: /* @__PURE__ */ d("div", { className: "position-relative w-100 h-100", children: [
            !g && /* @__PURE__ */ e(
              j,
              {
                kind: "spinner",
                className: "position-absolute top-50 left-50 translate-middle"
              }
            ),
            /* @__PURE__ */ e(
              "iframe",
              {
                src: S,
                className: g ? "h-100 w-100" : "h-0 w-0",
                onLoad: () => {
                  b(!0);
                }
              },
              `chat-bot-${E}`
            )
          ] }) }),
          /* @__PURE__ */ e(v.Footer, { children: /* @__PURE__ */ e(
            A,
            {
              kind: "secondary",
              onNeuClick: () => {
                T(E + 1), b(!1);
              },
              icon: "refresh",
              iconPosition: "end",
              className: "w-auto flex-grow-0",
              children: p("PageContent.Chatbot.Restart")
            }
          ) })
        ]
      }
    ),
    m && !N && !L && /* @__PURE__ */ e(
      A,
      {
        className: "position-fixed bottom-0 right-0 z-sticky m-4 neu-elevation-5",
        onNeuClick: () => {
          P(t.clearstepLink), C(!0);
        },
        children: p("PageContent.Clearstep.Open")
      }
    )
  ] });
};
export {
  W as Chatbot
};
